import { docReady } from '../helpers/docReady';
import '../../styles/templates/product.scss';
import { productGalleryCarousel } from '../sections/productGalleryCarousel';
import { productRecommendations } from '../sections/productRecommendations';
import initCustomiser from '../customiser';
docReady(() => {
    // console.log('product-template');
    productGalleryCarousel();
    productRecommendations();
    initCustomiser();
});
